import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
const AddIcon = props => /*#__PURE__*/React.createElement(Button, {
  color: "info",
  outline: true,
  onClick: props.onClick,
  title: "Add",
  className: "align-self-center ".concat(props.className)
}, props.addText);
export default AddIcon;